import pointPhotos from "../data/point-photos.json";

type PointPhotoEntry = {
  src: string;
  alt?: string;
  credit?: string;
};

type FeaturedImage = {
  node?: {
    sourceUrl?: string | null;
    altText?: string | null;
  } | null;
} | null;

type GalleryImage = {
  userGallery?: Array<{
    largeFullFile?: string | null;
    mediumfullFileUrl?: string | null;
  } | null> | null;
} | null;

const INDEX = pointPhotos as Record<string, PointPhotoEntry>;

function galleryUrl(gallery?: GalleryImage): string | null {
  const first = gallery?.userGallery?.find(Boolean);
  if (!first) return null;
  return first.mediumfullFileUrl || first.largeFullFile || null;
}

/** Prefer WP featured image; else gallery; else local override by point slug. */
export function resolvePointFeaturedImage(
  slug: string | null | undefined,
  featured?: FeaturedImage,
  gallery?: GalleryImage
): { node: { sourceUrl: string; altText: string } } | undefined {
  const wp = featured?.node?.sourceUrl;
  if (wp) {
    return {
      node: {
        sourceUrl: wp,
        altText: featured?.node?.altText || slug || "",
      },
    };
  }
  const fromGallery = galleryUrl(gallery);
  if (fromGallery) {
    return {
      node: {
        sourceUrl: fromGallery,
        altText: slug || "",
      },
    };
  }
  if (!slug) return undefined;
  const local = INDEX[slug];
  if (!local?.src) return undefined;
  return {
    node: {
      sourceUrl: local.src,
      altText: local.alt || slug,
    },
  };
}

export function getPointPhotoOverride(slug: string | null | undefined) {
  if (!slug) return null;
  return INDEX[slug] || null;
}
